import { useState } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { elegir, preferencia } from '../lib/tema';

// Claro, oscuro o el del sistema.
//
// TRES OPCIONES Y NO UN INTERRUPTOR. «Lo que diga el sistema» es lo
// correcto por omisión —el teléfono del almacén ya cambia solo al
// anochecer— pero no puede ser lo único: el mismo aparato se usa en un
// andén con sol de frente y en una cámara fría a media luz, y ahí quien
// decide es la persona.
//
// Con etiqueta y no solo con icono: un sol y una luna en un botón que
// alterna no dicen si muestran el estado actual o lo que va a pasar al
// pulsarlos, y eso se adivina probando. Aquí se ve cuál está elegida.
const OPCIONES = [
  ['sistema', 'Sistema', Monitor],
  ['claro', 'Claro', Sun],
  ['oscuro', 'Oscuro', Moon],
];

export default function SelectorTema() {
  const [actual, setActual] = useState(preferencia);

  function cambiar(valor) {
    elegir(valor);
    setActual(valor);
  }

  return (
    <div className="px-2.5 pt-1">
      <div id="etiqueta-tema" className="text-[11px] font-semibold uppercase tracking-wide text-gray-600 mb-1">
        Aspecto
      </div>
      {/* `radiogroup` y no tres botones sueltos: es UNA decisión con tres
          valores, y un lector de pantalla tiene que poder decir «2 de 3». */}
      <div role="radiogroup" aria-labelledby="etiqueta-tema"
           className="flex gap-1 bg-gray-100 rounded-lg p-0.5">
        {OPCIONES.map(([valor, etiqueta, Icono]) => (
          <button
            key={valor}
            type="button"
            role="radio"
            aria-checked={actual === valor}
            onClick={() => cambiar(valor)}
            title={etiqueta}
            className={`flex-1 flex items-center justify-center gap-1 py-1.5 rounded-md
                        text-[11px] font-semibold transition-colors ${
              actual === valor
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-800'}`}
          >
            <Icono className="h-3.5 w-3.5" aria-hidden="true" />
            {etiqueta}
          </button>
        ))}
      </div>
    </div>
  );
}
